import React from "react";
import { Link } from "react-router-dom";

import "../assets/themes/main2.css";
import "../assets/themes/orderdetails.css";
import "../assets/themes/profile.css";
import "../assets/themes/changepassword.css";
import "../assets/themes/trackorder.css";
import "../assets/themes/profilesetting.css";
import "../assets/themes/addressinfo.css";
import "../assets/themes/contact.css";
import "../assets/themes/myorder.css";
import "../assets/themes/about.css";
import "../assets/themes/personalinfo.css";

function MerchantProducts() {
  return (
    <>
      <section>
        {/* <div>
          <img
            className="img5"
            src="/assets/images/Banners/banner1.jpg"
            width="100%"
          />
        </div> */}
      </section>

      <section className="procrdpg">
        <div className="row">
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>

                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="marchantproduct">
              <img
                src="/assets/images/dairycrd.jpg"
                alt="Strawberry"
                className="img-fruit"
              />
              <h3>Strawberries</h3>
              <div className="control-btn leftrightbtn">
                <span className="prev leftarrow">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </span>
                <span className="next rightarrow">
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </div>
              <p>hug a vegetarian, save a cow</p>
              <div className="properties_qty">
                <div className="propertiesqty">
                  <h4>Quantity</h4>
                  <i className="fa fa-minus" aria-hidden="true"></i>
                  <span className="number">1</span>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div className="propertiesprices">
                  <h4>Total Price</h4>
                  <span className="price-inr">
                    <i className="fa fa-inr" aria-hidden="true"></i>
                    <span className="amount">7</span>
                  </span>
                </div>
                <div className="propertiesdelivery">
                  <h4>Delivery</h4>
                  <i className="fa fa-fighter-jet" aria-hidden="true"></i>
                  <span className="time">In 60 mins</span>
                </div>
                <Link to="/merchantprodetails">
                  <button className="ip-add-cart">Add to cart</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MerchantProducts;
